var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPalestine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0127C24.8366 32.0127 32 24.8493 32 16.0127C32 7.17614 24.8366 0.0126953 16 0.0126953C7.16344 0.0126953 0 7.17614 0 16.0127C0 24.8493 7.16344 32.0127 16 32.0127Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73981 10.4475H31.0054C28.7448 4.3547 22.8801 0.0126953 16.0007 0.0126953C11.5823 0.0126953 7.58275 1.80388 4.6875 4.69951L9.73981 10.4475Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73981 21.5779H31.0054C28.7448 27.6707 22.8801 32.0127 16.0007 32.0127C11.5823 32.0127 7.58275 30.2215 4.6875 27.3259L9.73981 21.5779Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68579 4.69897C-1.56258 10.9473 -1.56258 21.078 4.68579 27.3265C7.26786 24.7444 9.75117 22.2611 15.9995 16.0127L4.68579 4.69897Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0126953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalestine);
export default __webpack_public_path__ + "static/media/palestine.ea261e83.svg";
export { ForwardRef as ReactComponent };